import ProjectService from '../../services/projectAnalytics'

export const state = {}

export const mutations = {}

export const getters = {}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    init({ state, dispatch }) {},

    // eslint-disable-next-line no-unused-vars
    getInteractionsReport({ commit }, params) {
        return new Promise((resolve, reject) => { 
            ProjectService.getInteractionsReport(params).then(response=> {
                resolve(response.data)
            })
            .catch(error=>{ reject(error) })
        });
    },
    // eslint-disable-next-line no-unused-vars
    getInteractions({ commit }, params) {
        return new Promise((resolve, reject) => { 
            ProjectService.getInteractions(params).then(response=> {
                resolve(response.data)
            })
            .catch(error=>{ reject(error) })
        });
    },
    // eslint-disable-next-line no-unused-vars
    getGeneralTransactionsReport({ commit }, params) {
        return new Promise((resolve, reject) => { 
            ProjectService.getGeneralTransactionsReport(params).then(response=> {
                resolve(response.data)
            })
            .catch(error=>{ reject(error) })
        });
    },
    // eslint-disable-next-line no-unused-vars
    getGeneralTransactionsByDayReport({ commit }, params) {
        return new Promise((resolve, reject) => { 
            ProjectService.getGeneralTransactionsByDayReport(params).then(response=> {
                resolve(response.data)
            })
            .catch(error=>{ reject(error) })
        });
    },
    // eslint-disable-next-line no-unused-vars
    getTransactionsByDayCsv({ commit }, params) {
        return new Promise((resolve, reject) => { 
            ProjectService.getTransactionsByDayCsv(params).then(response=> {
                resolve(response.data)
            })
            .catch(error=>{ reject(error) })
        });
    }
  }
  